import React from 'react';

import { Box } from '@mui/material';

import { useGlobalProducts } from 'components/BusinessToolForm/hooks/useGlobalProducts';
import { ProductVolumesTable } from 'components/BusinessToolForm/Sections/BusinessOperations/ProductionSection/ProductionPlansAndSpecifics/components/ProductVolumesTable';
import {
  PRODUCTION_NAMES,
  prefix as productionPrefix,
} from 'components/BusinessToolForm/Sections/BusinessOperations/ProductionSection/utils/form';
import { GLOBAL_PRODUCTS_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

import { SalesPlanProductTable } from './components/SalesPlanProductTable';
import { SalesPlanProductVolumes } from './components/SalesPlanProductVolumes';
import { ISalesAndPlannedProducts } from './types';
import { prefix, SALES_NAMES } from '../../utils/form';

export const SalesAndPlannedProducts: React.FC<ISalesAndPlannedProducts> = ({ disabled = false }) => {
  const { products, salesPlanFields, handleAddProduct, handleRemoveProduct, productionFields } = useGlobalProducts();

  const tableName = concatWithDot(prefix, SALES_NAMES.PLANNED_PRODUCTS_VOLUME);
  const productionTableName = concatWithDot(productionPrefix, PRODUCTION_NAMES.PLANNED_PRODUCTS_VOLUME);

  return (
    <Box>
      <SalesPlanProductVolumes
        productsName={GLOBAL_PRODUCTS_NAME}
        fields={products}
        disabled={disabled}
        onAddRow={handleAddProduct}
        onRemoveRow={handleRemoveProduct}
      />
      <SalesPlanProductTable tableName={tableName} fields={salesPlanFields} disabled={disabled} />
      <ProductVolumesTable tableName={productionTableName} fields={productionFields} disabled={disabled} />
    </Box>
  );
};
